import type { InputHTMLAttributes } from "react";
import styles from "./FormField.module.css";
import { FieldError } from "./FieldError";

interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "id"> {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  helperText?: string;
}

export function TextField({
  id,
  label,
  value,
  onChange,
  error,
  required,
  helperText,
  ...rest
}: TextFieldProps) {
  const errorId = `${id}-error`;
  const helperId = `${id}-helper`;
  const describedBy =
    [helperText ? helperId : null, error ? errorId : null].filter(Boolean).join(" ") || undefined;

  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label} {!required && <span className={styles.optional}>(optioneel)</span>}
      </label>
      {helperText && (
        <span id={helperId} className={styles.helperText}>
          {helperText}
        </span>
      )}
      <input
        id={id}
        className={[styles.input, error ? styles.invalid : ""].filter(Boolean).join(" ")}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={Boolean(error) || undefined}
        aria-describedby={describedBy}
        aria-required={required || undefined}
        {...rest}
      />
      <FieldError id={errorId} message={error} />
    </div>
  );
}
